// src/features/locker-assignments/components/forms/NotesSection.tsx
import React from 'react';
import { TextInput, useTranslate } from 'react-admin';
import { Note as NoteIcon } from '@mui/icons-material';
import { MyFormSection } from '@/components';

interface NotesSectionProps {
  // No props necesarios ya que TextInput se maneja internamente con react-admin
}

export const NotesSection: React.FC<NotesSectionProps> = () => {
  const translate = useTranslate();
  
  return (
    <MyFormSection title={translate('resources.locker-assignments.messages.notes_title')} icon={<NoteIcon />}>
      <TextInput
        source="notes"
        label=""
        placeholder={translate('resources.locker-assignments.messages.notes_placeholder')}
        multiline
        rows={2}
        fullWidth
        variant="outlined"
      />
    </MyFormSection>
  );
};